import Modal from 'react-bootstrap/Modal';
import MapContainer, { MapContainerProps } from './MapContainer';

export interface MapVizModalProps extends MapContainerProps {
  showMap: boolean;
  setShowMap: (show: boolean) => void;
}

// modal component for map visualization
export default function MapVizModal({
  showMap,
  setShowMap,
  isEmbedded,
  ...props
}: MapVizModalProps) {
  return (
    <>
      <Modal
        show={showMap}
        animation={true}
        fullscreen={true}
        dialogClassName="modal-90w modal-90h"
        onHide={() => !isEmbedded && setShowMap(false)}
      >
        <Modal.Header closeButton={!isEmbedded}>
          <Modal.Title>SigCap Map Visualization</Modal.Title>
          {isEmbedded && (
            <div className="ms-auto d-flex align-items-center">
              <a
                href="https://people.cs.uchicago.edu/~muhiqbalcr/sigcap/"
                target="_blank"
                rel="noopener noreferrer"
                className="me-3"
                style={{ fontSize: '0.9rem' }}
              >
                About SigCap
              </a>
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: '0.9rem' }}
              >
                SigCap Data Platform
              </a>
            </div>
          )}
        </Modal.Header>
        <Modal.Body style={{ display: 'flex' }}>
          <MapContainer
            {...props}
            height={!isEmbedded ? '100%' : props.height}
            isEmbedded={isEmbedded}
            showMap={showMap}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
